import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const settings = useQuery({ queryKey: ["settings"], queryFn: async () => (await api.get("/settings")).data });
  const nav = useQuery({ queryKey: ["navigation"], queryFn: async () => (await api.get("/navigation")).data });
  const blogCategories = useQuery({ queryKey: ["blog-categories", "navigation"], queryFn: async () => (await api.get("/blog-categories")).data });
  const pageContent = useQuery({ queryKey: ["page-content"], queryFn: async () => (await api.get("/page-content")).data });
  const seo = useQuery({ queryKey: ["seo"], queryFn: async () => (await api.get("/seo")).data });

  const s = settings.data || {};
  if (typeof document !== "undefined") {
    document.documentElement.classList.toggle("btn-accent", s.button_color === "accent");
  }

  return (
    <SiteContext.Provider value={{ settings: s, nav: nav.data || [], blogCategories: blogCategories.data || [], pageContent: pageContent.data || {}, seo: seo.data || {} }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext) || { settings: {}, nav: [], blogCategories: [], pageContent: {}, seo: {} };
